import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Banknote icon for payment-related actions.
 */
export const BanknoteIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <rect x="3" y="6" width="18" height="12" rx="2" ry="2" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M7 9h.01M17 15h.01" />
      <path d="M5.5 9.5A2.5 2.5 0 0 0 8 7h8a2.5 2.5 0 0 0 2.5 2.5v5A2.5 2.5 0 0 0 16 17H8a2.5 2.5 0 0 0-2.5-2.5z" />
    </Icon>
  );
};

export default BanknoteIcon;
